import React, {Component} from 'react';
import withRecognizerForMemorizeB from "./withRecognizerForMemorizeB";
import withRecognizerDialogue from "./withRecognizerDialogue";
import MicVisualizer from "../other/MicVisualizer";
import {isIOS} from "../../asset/js/myFunctions";

class Footer_MDB extends Component {

    constructor(props) {
        super(props);
        this.state={
            index:999,
            recording: false,
            audioURL: null,
        };
        this.endRecognitionTimer = null;

    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.listening && !this.props.listening) {
            this._clearEndRecognitionTimer();
        }

        if(!prevProps.letStartRecognition && this.props.letStartRecognition) {
            this.props.startRecognition();
            if(this.props.serverData.user_kind === "K"){
                this._scheduleEndRecognition(this.props.contents[this.props.playingIndex].eng_content.length * 200);

            } else if(this.props.serverData.step_code === "L3"){
                this._scheduleEndRecognition(1 + this.props.contents[this.props.playingIndex].eng_content.length * 145);
            }
        }
    }

    componentWillUnmount() {
        this._clearEndRecognitionTimer();
    }


    render() {

        if(this.props.showContinue) {
            return (
                <section className="view-footer">
                    <button
                        type="button"
                        className="f-btn f-center btn-test"
                        onClick={() => {
                            this.props.resetAudioContext();
                        }}> 테스트
                    </button>
                </section>
            )
        }

        if(!this.props.isPlaying && !this.props.listening && this.props.isTesting) {
            //대화가 넘어가는 틈 OR 녹음 도중 에러가 발생함.
            return (
                <section className="view-footer">
                    {this.props.err === null ?
                        <button type="button" className="f-btn">Empty</button>
                        :
                        <button
                            type="button"
                            className="f-btn f-center btn-test"
                            onClick={() => {
                                const recognitionIndex = this._getRecognitionIndex();
                                const content = this.props.contents && this.props.contents[recognitionIndex];

                                if(!content) {
                                    return;
                                }

                                if(isIOS){
                                    this.props.fakeRecognitionStart();
                                    this.props.audioPlayMute("eng", recognitionIndex,
                                        () => setTimeout(() => {this.props.fakeRecognitionEnd()},1000)
                                    );
                                } else {
                                    this.props.startRecognition();
                                    if(this.props.serverData.user_kind === "K"){
                                        this._scheduleEndRecognition(content.eng_content.length * 200);

                                    } else if(this.props.serverData.step_code === "L3"){
                                        this._scheduleEndRecognition(1 + content.eng_content.length * 110);
                                    }
                                }

                                this.props.handleError(null);
                                this.props.closeTip();
                            }}> 테스트
                        </button>
                    }


                </section>
            )
        }

        return (
            <section className="view-footer">
                <button type="button" className="f-btn">Empty</button>
                {this.props.listening ?
                    <MicVisualizer/>
                    :
                    this.props.isPlaying ?
                        <button
                            type="button"
                            className="f-btn f-center btn-listen"
                        > 듣는중</button>
                        :
                        <div className="f-center-grouping">
                            <button
                                type="button"
                                className="f-btn f-center-multiple btn-listen-all"
                                onClick={() => this._readyTest()}>전체 듣기
                            </button>
                            <button
                                type="button"
                                className="f-btn f-center-multiple btn-test"
                                onClick={() => {
                                    this.props.memorizeBTest(0);
                                }}> 테스트
                            </button>
                        </div>


                }

                {this.props.numOfPair <= this.props.currentPhase.index + 1?

                    this.props.currentPhase.pass && !this.props.isPlaying && !this.props.listening ?
                        <button
                            type="button"
                            className="f-btn btn-next-page"
                            onClick={() => {
                                this.props.goNextMenu()
                                //this._memorizeBFinalTest();
                            }}>다음 메뉴</button>
                        :
                        <button type="button" className="f-btn">Empty</button>
                    :
                    this.props.currentPhase.pass && !this.props.isPlaying && !this.props.listening ?
                        <button
                            type="button"
                            className="f-btn btn-next"
                            onClick={() => {this.props.nextPhase()}}>다음페이즈</button>
                        :
                        <button type="button" className="f-btn">Empty</button>

                }

            </section>

        );
    }

    _readyTest = () => {
        // this.props.playTill();
        this.props.audioPlayRange(0, 0, (this.props.currentPhase.index * 2) + 1 )
        if(this.props.isReadyTest === false){
            this.props.toggleReadyTest();
        }
    };


    _memorizeBFinalTest = () => {
        this.props.memorizeBFinalTest();
    }

    _scheduleEndRecognition = (duration) => {
        this._clearEndRecognitionTimer();
        this.endRecognitionTimer = setTimeout(() => {
            this.props.endRecognition();
            this.endRecognitionTimer = null;
        }, duration);
    }

    _clearEndRecognitionTimer = () => {
        if(this.endRecognitionTimer !== null) {
            clearTimeout(this.endRecognitionTimer);
            this.endRecognitionTimer = null;
        }
    }

    _getRecognitionIndex = () => {
        if(this.props.testingIndex != null) {
            return this.props.testingIndex;
        }

        if(this.props.currentIndex != null) {
            return this.props.currentIndex;
        }

        if(this.props.playingIndex != null) {
            return this.props.playingIndex;
        }

        return 0;
    }

}

// export default withRecognizerForMemorizeB()(Footer_MDB);
export default withRecognizerDialogue()(Footer_MDB);
    
